// AllDocuments.js
import { useEffect, useState } from "react";
import axios from "axios";
import api from "../../api";




const DOC_TYPES = ["ALL", "FCD", "LIT", "ECN", "SOP", "WI"];
const SHOW_OPTIONS = ["Released", "Archived", "All", "MyDocs"];
const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const AllDocuments = ({ children }) => {
    const [documents, setDocuments] = useState([]);
    const [totalCount, setTotalCount] = useState(0);

    // Filters
    const [docType, setDocType] = useState("ALL");
    const [show, setShow] = useState("Released");
    const [search, setSearch] = useState("");
    const [author, setAuthor] = useState("");
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(25);
    const [loading, setLoading] = useState(false);

    const fetchDocuments = async () => {
        setLoading(true);
        try {
            const params = { page, pageSize, docType, show };
            if (show === "MyDocs" && author) params.author = author;
            if (search) params.search = search;

            const res = await api.get(`dms/alldocuments`, { params });
            setDocuments(res.data.items || []);
            setTotalCount(res.data.totalCount || 0);
            console.log("DMS Data loader:", res.data.totalCount);
        } catch (err) {
            console.error("❌ Documents fetch error:", err.message || err);
            alert("Error fetching documents");
        }
        setLoading(false);


    };

    useEffect(() => {
        fetchDocuments();
        // eslint-disable-next-line
    }, [page, pageSize, docType, show, search, author]);

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        setPage(1);
        fetchDocuments();
    };

    const totalPages = Math.ceil(totalCount / pageSize);

    // gridData for table
    const gridData = documents.map(doc => [
        doc.docId,
        doc.docTitle,
        doc.rev,
        doc.author,
        doc.status,
        doc.docType,
        doc.createdDate?.split("T")[0],
    ]);

    // Pass all control props to children using a render prop
    return children({
        gridData,
        loading,
        page,
        totalPages,
        totalCount,
        setPage,
        pageSize,
        setPageSize,
        docType,
        setDocType,
        show,
        setShow,
        search,
        setSearch,
        author,
        setAuthor,
        DOC_TYPES,
        SHOW_OPTIONS,
        PAGE_SIZE_OPTIONS,
        handleSearchSubmit,
    });
};

export default AllDocuments;
